import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    adminInfo: null
  },
  mutations: {
    setAdminInfo (state, adminInfo) {
      state.adminInfo = adminInfo
    },
    clearAdminInfo (state) {
      state.adminInfo = null
    }
  }
})
